import { COUNTRY_NAME } from "../../components/Common/constants";

export const DISABLED_COUNTRIES_BY_LANGUAGE = {
  jap: new Set([
    COUNTRY_NAME.UNITEDKINGDOM,
    COUNTRY_NAME.INTERNATIONALEUROCARD,
  ]),
};

export const NO_DISABLED_COUNTRIES = new Set();
